import { render } from "./monthlyVideos.vue?vue&type=template&id=25b97831"
import script from "./monthlyVideos.vue?vue&type=script&lang=js"
export * from "./monthlyVideos.vue?vue&type=script&lang=js"

import "./monthlyVideos.vue?vue&type=style&index=0&id=25b97831&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__